/*
 * File: main.js
 * Project: <<marketing-system>>
 * File Created: 2018-8-21 11:51:4 AM
 * Author: xiongyang (yang.xiong@meicloud.com)
 * -----
 * Last Modified: 2018-05-30 5:12:24 pm
 * Modified By: xiongyang (yang.xiong@meicloud.com>) (<<git>>)
 * -----
 * Copyright © 2018 - MeiCloud, MeiCloud
 */

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import 'normalize.css';// A modern alternative to CSS resets
import Element from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/styles/index.scss'; // global css
import '@/styles/fonts/iconfont.css'; // 字体图标库

import App from './App';
import router from './router';
import store from './store';
import './directive'; // 全局自定义指令
import './components'; // 全局自定义组件
import * as filters from './filters'; // global filter

import './utils/messageBus'; // 全局自封装message 弹框
import VueClipboard from 'vue-clipboard2'; // 剪切板
import { getSession } from '@/utils';
import { getScript } from '@/utils/bigData';

import addRouterAuth from '@/router/addRouterAuth.js';
// 一些全局公用的方法
import commonEvent from './utils/commonEvent'; // 添加
// 多选联级下拉框
import elCascaderMulti from 'el-cascader-multi';
// 前端监控系统
import './utils/error/windowError';

import Plugins from './plugins';
import echarts from 'echarts';
Vue.use(Plugins);

// 引入echarts
Vue.use(commonEvent);
Vue.use(elCascaderMulti);
Vue.prototype.$echarts = echarts;
Vue.use(VueClipboard);

// register global utility filters.
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key]);
});

// 自定义Array的indexOf方法1
if (!Array.indexOf) {
  Array.prototype.indexOf = el => {
    for (var i = 0; i < this.length; i++) {
      if (this[i] === el) {
        return i;
      }
    }
    return -1;
  };
};

// replaceAll兼容方案
if (!String.replaceAll) {
  String.prototype.replaceAll = function(s1, s2) {
    return this.replace(new RegExp(s1, 'gm'), s2);
  };
}

// 使用element-ui
Vue.use(Element);

Vue.config.productionTip = false;

// 刷新的时候
if (getSession('isHadSetMenu') && getSession('routeMenu') && getSession('routeMenu').length > 0) {
  addRouterAuth({
    callback: () => {
      // 进入路由
      // 在刷新页面的时候，需要先加菜单后进入页面,避免跳转去首页
      // console.log('刷新页面');
      store.dispatch('user/flagGetAuthList', false);
    }
  }, false, null, 3);
}

const BIG_DATA = process.env.BIG_DATA;
const BURY_ENABLE = process.env.BURY_ENABLE;

function importBigDataJs() {
  const mainLog = BIG_DATA + '/kfk/js/mainLog.js';
  const sha1 = BIG_DATA + '/kfk/js/sha1.js';
  const detailLog = BIG_DATA + '/kfk/js/detailLog.js';
  getScript(mainLog);
  getScript(sha1);
  getScript(detailLog);
}
// 是否开启数据埋点
if (BURY_ENABLE === 'true') {
  importBigDataJs();
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
});
